import { useMemo } from 'react';
import { useLanguageSelectListQuery } from 'api';

export const useLanguageMapping = (): Record<string, any> => {
  const { data: languageList = [] } = useLanguageSelectListQuery();
  const languageMapping: Record<string, { name: string; id: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; id: string }> = {};
    languageList.forEach((i: { name: string; id: string }) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [languageList]);

  return {
    languageMapping,
  };
};
